<div class="container">
    <div class="main-body">


        <!-- /Breadcrumb -->

        <div class="row gutters-sm">
            <div class="col-md-4 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex flex-column align-items-center text-center">
                            <img src="https://bootdey.com/img/Content/avatar/avatar7.png" alt="Admin"
                                class="rounded-circle" width="150">
                            <div class="mt-3">
                                <h4>{{user.firstName}}</h4>
                                <p class="text-secondary mb-1">Full Stack Developer</p>
                                <p class="text-muted font-size-sm">Bay Area, San Francisco, CA</p>

                            </div>

                        </div>
                    </div>
                    <div class="card-actions">
                        <div class="list-group list-group-flush">
                            <a (click)="changeSelectedAction(1)"
                                [ngClass]="selectedAction==1?'list-group-item list-group-item-action active':'list-group-item list-group-item-action'"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-user mr-3">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg> Profile</a>
                            <a (click)="changeSelectedAction(2)"
                                [ngClass]="selectedAction==2?'list-group-item list-group-item-action active':'list-group-item list-group-item-action'"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-shopping-bag mr-3">
                                    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                                    <line x1="3" y1="6" x2="21" y2="6"></line>
                                    <path d="M16 10a4 4 0 0 1-8 0"></path>
                                </svg> Orders</a>
                            <!-- <a href="#/WishList" class="list-group-item has-badge list-group-item-action"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-heart mr-3">
                                    <path
                                        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
                                    </path>
                                </svg> Wishlist</a> -->
                            <!--<a href="account-address.html" class="list-group-item list-group-item-action"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map mr-3"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line></svg> Address</a>-->
                            <a (click)="logout()" class="list-group-item list-group-item-action text-danger"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-log-out mr-3">
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                    <polyline points="16 17 21 12 16 7"></polyline>
                                    <line x1="21" y1="12" x2="9" y2="12"></line>
                                </svg> Logout</a>
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-md-8">
                <div class="card" *ngIf="selectedAction==1">
                    <div class="card-header">
                        <h5 class="title">My Profile</h5>
                    </div>


                    <div class="card-body">

                        <form class="form-style-1 font_bold ng-pristine ng-valid ng-valid-required" name="form1"
                            ng-submit="">
                            <div class="form-row">
                                <div class="form-group col-sm-6">
                                    <label for="profileFirstName">First Name</label>
                                    <input type="text" class="form-control ng-pristine ng-valid ng-valid-required"
                                        id="profileFirstName" ng-model="customerInfo.FirstName" required="">
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="profileLastName">Last Name</label>
                                    <input type="text" class="form-control ng-pristine ng-valid ng-valid-required"
                                        id="profileLastName" ng-model="customerInfo.LastName" required="">
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="profileEmail">Email address</label>
                                    <input type="email"
                                        class="form-control ng-pristine ng-valid-email ng-valid ng-valid-required"
                                        id="profileEmail" ng-model="customerInfo.Email" required="">
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="profilePhone">Phone Number</label>
                                    <input type="text" class="form-control ng-pristine ng-valid ng-valid-required"
                                        id="profilePhone" ng-model="customerInfo.Phone" required="">
                                </div>

                                <div class="form-group col-12">
                                    <button type="submit" ng-click="changeprofile()" ng-disabled="!form1.$valid"
                                        class="btn btn-theme"><i class="fa fa-check" aria-hidden="true"></i> UPDATE
                                        PROFILE</button>
                                </div>
                            </div>
                        </form>

                        <hr>
                        <form class="form-style-1 font_bold ng-pristine ng-invalid ng-invalid-required" name="form2"
                            ng-submit="">
                            <div class="form-row">
                                <hr>
                                <div class="form-group col-sm-6">
                                    <label for="profileNewPassword">Old Password</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                                        </div>

                                        <input class="form-control ng-pristine ng-invalid ng-invalid-required"
                                            name="OLDPassword" id="OLDPassword" placeholder="**********"
                                            ng-model="changepass.OldPassword" type="password" required="">
                                    </div>
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="profileNewPassword">New Password</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                                        </div>
                                        <input class="form-control ng-pristine ng-invalid ng-invalid-required"
                                            name="NewPassword" id="NewPassword" placeholder="***********"
                                            ng-model="changepass.NewPassword" type="password" required="">
                                    </div>
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="profileConfirmPassword">Confirm Password</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                                        </div>
                                        <input class="form-control ng-pristine ng-invalid ng-invalid-required"
                                            name="ConfirmPassword" id="ConfirmPassword" placeholder="***********"
                                            ng-model="changepass.ConfirmPassword" type="password" required="">
                                    </div>
                                </div>
                                <div class="form-group col-12">
                                    <button type="submit" ng-click="changepPASSWORD()" ng-disabled="!form2.$valid"
                                        class="btn btn-theme" disabled="disabled"><i class="fa fa-check"
                                            aria-hidden="true"></i>
                                        UPDATE PASSWORD</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="card" *ngIf="selectedAction==2">
                    <table class="table table-bordered table-responsive">
                        <thead class="bg-info color-white">
                            <tr>
                                <th>Order Id</th>
                                <th>Order Date</th>
                                <th>Order Total</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let order of allOrders">
                                <td>{{order.orderNumber}}</td>
                                <td>{{order.orderdate}}</td>
                                <td>{{order.total}}</td>
                                <td>{{order.orderstatus}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>